// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__lraHw","copy":"Hero_copy__cC37B","title":"Hero_title__I7XVL","subline":"Hero_subline__fVcYm","media":"Hero_media__0KWuA"};